<template>
  <span class="text-black-50 font-weight-light">{{ progress }} {{message}}</span>
</template>

<script>
import firebaseSrv from '@/services/firebaseSrv.js'
import NProgress from 'nprogress'
// import path from 'path'

export default {
  data() {
    return {
      progress: 0,
      message: ''
    }
  },
  props: ['meta', 'eid'],
  methods: {
    sanatisedFileName(value) {
      var random = Math.floor(Math.random() * 1000)
      var desired = value.replace(/\.[^/.]+$/, '')
      var short = desired.replace(/[^\w\s]/gi, '')
      var space = short.replace(/\s/g, '')
      var trimmed =
        space.length > 64 ? `${random}_${space.substring(0, 64)}` : space
      // console.log('entryID appeneded to file name:' + trimmed + '_' + this.eid)
      return this.eid + '_' + trimmed
    },
    progressFn(progress) {
      this.progress = progress
    },
    messageFn(message) {
      this.message = message
    },
    pathFn(path, fileName, folderName) {
      let uploadMeta = {
        path: path,
        fileName: fileName,
        folderName: folderName
      }
      // this.path = path
      // console.log(path, fileName, folderName)
      this.$emit('uploaded', uploadMeta)
    },

    upload() {
      NProgress.start()
      const fileName = this.sanatisedFileName(this.meta.file.name) + '.jpg'
      console.log(fileName)
      const folderName = firebaseSrv.auth.currentUser.uid
      const metadata = { contentType: 'image/jpeg' }
      // console.log('user:' + this.user.user.id)
      var uploadTask = firebaseSrv.storageRef
        .child(folderName + '/' + fileName)
        .put(this.meta.file, metadata)

      // Register three observers:
      // 1. 'state_changed' observer, called any time the state changes
      // 2. Error observer, called on failure
      // 3. Completion observer, called on successful completion
      uploadTask.on(
        'state_changed',
        function(snapshot) {
          // Observe state change events such as progress, pause, and resume
          // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
          var progress = Math.round(
            (snapshot.bytesTransferred / snapshot.totalBytes) * 100
          )
          this.progressFn(progress + '%')
          this.messageFn('Uploading')
          /*
          switch (snapshot.state) {
            case firebaseSrv.firebase.storage.TaskState.PAUSED: 
              this.message(' Upload paused ')
              break
            case firebaseSrv.firebase.storage.TaskState.RUNNING: 
              this.messageFn('Upload running')
              break
          }
          */
        }.bind(this),
        function(error) {
          // Handle unsuccessful uploads
          this.messageFn('Upload failed')
          console.log(error)
        },
        () => {
          // Handle successful uploads on complete
          uploadTask.snapshot.ref.getDownloadURL().then(downloadURL => {
            NProgress.done()
            this.messageFn('Upload complete')
            return this.pathFn(downloadURL, fileName, folderName)
          })
        }
      )
    }
  },
  created() {
    this.upload()
  }
}
</script>

<style scoped>
</style>
